export interface GameDetails {
    codes: string;
    names: string;
    type: string;
    userOptedIn: boolean;
    disclaimer?: string;
    gameLink?: string;
    rulesLink?: string;
    tokenLabelSingular?: string;
    tokenLabelPlural?: string;
    programMinAge? : number;
    disableGamePlay?: boolean;
    aaisIntegrationEnabled?: boolean;
}

export interface GameModalMessage {
    mode: number;
    gameId?: string;
    gameName?: string;
    prizeDetail?: PrizeDetail;
    rulesLink?: string;
    userInfo?: any;
    disableGamePlay?:boolean;
    elementEvent?: any;
}

export interface GamePoints {
    totalGamePoints: number;
    totalPrizesWon: number;
}

export interface GameModel {
    name: string,
    type: string,
    description: string,
    details: string,
    code: string,
    endDate: any,
    postProgLiveDate?: any,
    totalGamePoints: string,
    totalPrizesWon: string,
    sweepstakesEntries: string,
    gameplaysUsed: string,
    gameStatus?: string,
    faqurl?: string,
    rulesurl?: string,
    minAge?: number,
    disableGamePlay?: boolean,
    endDateString?: string,
    howItWorks?: any
}

export interface PrizeDetail {
    availableCount: number
    burnPoints: number;
    description: string;
    digitalPrize: boolean;
    disclaimer: string;
    earnPoints: number;
    expirationDate: string;
    initialStockCount: number;
    name: string;
    prizeId: string;
    programCode: string;
    ranking: number;
    sweepstakeDrawDate: string;
    type: string;
    vendor: string;
    image?: string;
    imageId?: string;
}

export interface Prizes {
    prizes: PrizeDetail[];
    isFreshPassSubscribedUser: boolean;
    serviceErrors?: any;
}

export const GameMessageType = {
    INELIGIBLE: 1,
    PRIZEREDEEM: 2,
    SHOWHOWITWORKS: 3,
    SHOWOPTIN: 4,
    SHOWSWEEPSTAKES: 5,
    SHOWGAMESUMMARY: 6,
    SHOWOPTINFROMPRIZE: 7,
}

export interface MyPrize {
    prizeId: string;
    uuid: string;
    description: string;
    prizeFulfillmentDate: string;
    prizeFulfillmentStatus?: string;
    purchaseDate: string;
    sweepstakeDrawDate: string;
    programCode: string;
    prizeType: string;
    status: string;
    sweepstakeInfo?: {
        header: string,
        totalSweepStakePrizes: number,
        drawingDaysLeft: number,
        subtext: string,
    };
    imageId?: string;
}

export interface AddressDetail {
    firstName: string,
    lastName: string,
    address: string,
    address2: string,
    state: string,
    city: string,
    addressId: string,
    zipCode: string
}

export interface AddressCombined {
    addresses: Array<AddressDetail>,
    firstName: string,
    lastName: string,
    primaryemail: string,
    phoneNumber: string,
    customerType: string,
}

export interface TransactionHistory {
    activity: string,
    eventSource: string,
    modifiedTs: string,
    quantityProcessed: number,
    quantityRequested: number,
    totalBalance: number,
    transactionId: number,
    transactionTs: string,
    transactionType: string
}

export interface SweepstakesWinner {
    displayed: boolean,
    drawDate: string,
    winnerEmail: string,
    expirationDate: string,
    prizeId: string,
    prizeName: string,
    programCode: string,
    winningDetails: string,
    deadlineDate: string
}
export interface ProgramStatusWithTimeStamp {
    program: string,
    status: string
}
export interface OptInRequestModel {
    firstName?: string,
    lastName?: string,
    email?: string,
    enrollments: Array<ProgramStatusWithTimeStamp>,
    oldFirstName?: string,
    oldLastName?: string,
    oldEmail?: string,
    oldDateOfBirth?:string,
    dateOfBirth?:string,
    oldPhone?:object,
    phone? : object
}
export interface ProfileType {
    firstName: string,
    lastName: string,
    email: string,
    optin: boolean,
    subscriptionValue: string,
    effectiveTimePeriods: object,
    profileErrorMsg?:'',
    phones?:Array<{number: string, purposes: Array<{}>, type: string}>
}
